import { render, staticRenderFns } from "./ApprovalConfigDetailTable.vue?vue&type=template&id=36060a7f&scoped=true"
import script from "./ApprovalConfigDetailTable.vue?vue&type=script&lang=js"
export * from "./ApprovalConfigDetailTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfigDetailTable.vue?vue&type=style&index=0&id=36060a7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36060a7f",
  null
  
)

export default component.exports